import { WantedJobPostingResponse } from '~hooks/query/company/useWantedJobPosting';
import { formattedMoney } from '~utils/formatted/number';

import * as S from './style';

type WantedCompanyInfo = Pick<WantedJobPostingResponse['company'], 'name'>;
interface Props extends Pick<WantedJobPostingResponse, 'is_recommended'>, WantedCompanyInfo {
  PK_NM_HASH: string;
  position: string;
  reward: number;
  href: string;
  onClick?: () => void;
}

export default function JobPostingCard({
  PK_NM_HASH,
  name: companyName,
  is_recommended: isRecommended,
  position,
  reward,
  href,
  onClick,
}: Props) {
  return (
    <S.Wrapper
      href={href}
      onClick={onClick}
      target='_blank'
      data-attribute-id='company__position__click'
      data-company-hash={PK_NM_HASH}
      data-company-name={companyName}
      data-connection={isRecommended ? '추천기업 채용 공고' : '채용 공고'}>
      <S.InnerWrapper>
        <S.Title>{position}</S.Title>
        <S.Reward>채용 보상금: {formattedMoney(reward)} 원</S.Reward>
      </S.InnerWrapper>
    </S.Wrapper>
  );
}
